export default __webpack_public_path__ + "0b195c5c2ce53efc69c59f1c408f7a93.jpg";